export default __webpack_public_path__ + "static/media/computer.2dcea523.svg";